import { Outlet } from '@tanstack/react-router';
import { Suspense } from 'react';
import RootLayoutSuspenseFallback from '@/components/RootLayoutSuspenseFallback.tsx';

export default function RootLayout() {
  return (
    <Suspense fallback={<RootLayoutSuspenseFallback />}>
      <Outlet />
    </Suspense>
  );
}
